import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div<{ margin?: string }>`
    display: ${(props: any) => (props.hideDesktopHeader ? 'none' : 'flex')};
    justify-content: space-between;
    align-items: center;
    //width: 100%;
    background: #fff;
    height: 76px;
    margin: ${(props: any) => props.margin || '0  auto'};
    padding: 0 120px;
    border-bottom: 1px solid #e7e7f0;

    &.showMobView {
        border: none;
        padding: 0 20px;
        height: 50px;

        #headerLogo {
            display: none;
        }

        #headerBack {
            display: block;
        }
    }

    @media (max-width: 700px) {
        display: ${(props: any) => (props.hideMobileHeader ? 'none' : 'flex')};
        padding: 0 20px;
        height: 50px;
        border: none;
    }
`;

export const LogoWrapper = styled.div`
    height: 26px;
    cursor: pointer;

    @media (max-width: 700px) {
        display: none;
    }
`;

export const Logo = styled.img`
    height: 24px;
    cursor: pointer;
`;

export const IconWrapper = styled.div`
    display: none;
    cursor: pointer;
    z-index: 1000;

    @media (max-width: 700px) {
        display: block;
    }
`;

export const HelpCTA = styled.div`
    display: flex;
    align-items: center;
    height: 25px;
    width: max-content;
    border: 1px solid #040222;
    border-radius: 4px;
    padding: 0 8px;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;

    & > span {
        margin: 0 0 0 6px;
    }
`;
